import type { SkillKind } from '@mezha/api'
import type { EmblemName } from '../../ui/brand/Emblems'

/** Kinds of skills (combat_system_v2.md §7.2). */
export const KIND_RU: Record<SkillKind, string> = {
  technique: 'приём', stance: 'стойка', spell: 'заговор', sign: 'знак', passive: 'умение', master: 'мастерский приём',
}

/** The sign of each kind until the skill art arrives (art_prompts_ui.md, «Умения»). */
export const KIND_EMBLEM: Record<SkillKind, EmblemName> = {
  technique: 'skill.technique', stance: 'skill.stance', spell: 'skill.spell', sign: 'skill.sign', passive: 'skill.passive', master: 'skill.master',
}

/** Why a skill of the set cannot be chosen now (server BattleSkill.block). */
export const BLOCK_RU: Record<string, string> = {
  weapon: 'нужно другое оружие', used: 'уже применено в этом бою', cooldown: 'ещё не готово', focus: 'не хватает напора', mana: 'не хватает маны',
  stunned: 'вы оглушены', silenced: 'вы в забытьи',
}

/** What the weapon in hand lacks for a skill (server SkillBookItem.missing). */
export const MISSING_RU: Record<string, string> = { shield: 'нужен щит', two_handed: 'нужно двуручное оружие', family: 'нужно оружие школы' }

export const TIER_RIM = ['I', 'II', 'III', 'IV', 'V'] as const
export const GATE_RU: Record<string, string> = { lesson: 'урок наставника', auto: 'по мастерству', trial: 'испытание наставника' }

/** The price of a skill as a tag: ◆2 or «3 маны». */
export function costText(focus: number, mana: number): string {
  if (focus) return `◆${focus}`
  if (mana) return `${mana} маны`
  return ''
}

/** «1 раунд», «2 раунда», «5 раундов». */
export function roundsText(n: number): string {
  const m10 = n % 10, m100 = n % 100
  const w = m10 === 1 && m100 !== 11 ? 'раунд' : m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14) ? 'раунда' : 'раундов'
  return `${n} ${w}`
}
